export class DefaultValueConstants { 
    public static readonly Default_Tree_Selection_Mode: string = 'Single';

    // Toaster Message Severity 
    public static readonly Severity_Success: string = 'success';
    public static readonly Severity_Info: string = 'info';
    public static readonly Severity_Err: string = 'error';

    //Speed dial component's styling constants
    public static readonly Quarter_Circle_DialType:string='quarter-circle';
    public static readonly Linear_DialType:string='linear';
    public static readonly Left_DialDirection:string='left';
    public static readonly Left_Down_DialDirection:string='down-left';  

    //User Home Defaut values
    public static readonly myDelegations_label:string='My Delegations';
    public static readonly todelegations_label:string='Delegated To Me';
    public static readonly myEmployees_label:string='My Training Plan Reviews';
    public static readonly myPeriodicReviews_label:string='My Periodic Reviews';
    public static readonly myChangeRequests_label: string = 'My Change Requests';
    public static readonly myChangeRequests_routerLink:string='My Change Requests';
    public static readonly delegation_label:string='Delegation';
    public static readonly userProfile_label:string='User Profile';
    public static readonly myAssignedAdmin_label:string='My Assigned Admin';
    public static readonly myFavorites_label: string = 'My Favorites';
    public static readonly pending_label: string = 'Pending';
    public static readonly terminated_label: string = 'Terminated';
    public static readonly active_label: string = 'Active';
    public static readonly total_label: string = 'Total';

    //Footer value
    public static readonly eQMS_Footer:string='(c) 2007-2023 Eurofins Scientific | Testing Laboratories Company';
   

    //Training Default values
    public static readonly myUserProfile_label:string='User Profile';

    //Training Plan Review Constants
    public static readonly pendingReview_label: string = 'Pending Review';
    public static readonly reviewUpToDate_label: string = 'Review Up To Date';
    public static readonly terminatedUsers_label: string = 'Terminated Users';
    public static readonly activeUsers_label: string = 'Active Users';
    public static readonly TabMyEmployees: string = 'myEmployees';
    public static readonly UserProfileUrlPath : string = "/my-space/eqms.user-profile?";

    


}
